import React from "react"

import ShortLogo from '../images/procmart-short-logo.png'
import "./index.css"


const Loading = (props) => {
    const { visible } = props

    if (!visible) {
        return null
    }

    return (
        <div className="loader-overlay">
            <div className="loader-content">
                <div className="loaderClass">
                    <img src={ShortLogo} alt="" style={{ backgroundColor: '#f0f8ff38' }} />
                </div>
            </div>
        </div>
    )
}

export default Loading


/*import React, { useState } from "react"
import { Dialog } from 'primereact/dialog'

import LogoCircle from '../images/logo-circle.png'

import "./index.css"

const Loading = (props) => {
    const { visible } = props

    return (
        <div className="">
            <Dialog visible={visible} headerStyle={{display: 'none'}} contentStyle={{background: 'none', boxShadow: 0, display: 'flex', justifyContent: 'center', overflow: 'hidden'}} className="loading-modal" style={{ width: '50vw' }} >
                <div className="loaderClass">
                    <img src={LogoCircle} alt="" style={{ backgroundColor: '#f0f8ff38' }} />
                </div>
            </Dialog>
        </div>
    )
}

export default Loading*/